import { LegalClientKnowledgeAndExperienceParam } from 'api/types/params';
import { isYes } from 'helpers';

import { KnowledgeAndExperienceFormType } from '../../forms/knowledgeAndExperienceForm';

export const getKnowledgeAndExperienceSubmitData = (
  values: KnowledgeAndExperienceFormType
): LegalClientKnowledgeAndExperienceParam => ({
  financialInstruments:
    values.knowledgeAndExperience?.financialInstruments?.map((v) => v.value),
  otherFinancialInstrument:
    values.knowledgeAndExperience?.otherFinancialInstrument,
  hasQualifiedOfficersForInvestmentDecisions: isYes(
    values.knowledgeAndExperience?.hasQualifiedOfficersForInvestmentDecisions
  ),
  educationLevel: values.knowledgeAndExperience?.educationLevel?.value,
  heldFinancialPositionInLast5Years:
    values.knowledgeAndExperience
      ?.hasQualifiedOfficersForInvestmentDecisions !== undefined
      ? isYes(
          values.knowledgeAndExperience
            ?.hasQualifiedOfficersForInvestmentDecisions
        )
      : undefined,
});
